module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_types_of_cells_4-3e8005dd96df527cd10bd472a72f341f.jpg";